import React from "react";
import { Typography } from "@mui/material";
import WaitTimeForm from "components/dashboard/WaitTimeForm";
import CapabilitiesForm from "components/dashboard/CapabilitiesForm";

const StatusBoardPage = ({ data }) => {
  return (
    <div className="inner">
      <Typography
        variant="h4"
        component="h2"
        sx={{ mt: { xs: 1, sm: 5 }, mb: 2 }}
      >
        Status Board
      </Typography>

      <Typography variant="body" sx={{ display: "block", mt: 1, mb: 4 }}>
        Update the status of your facility's waiting room to let potential
        patients know how long they'll be waiting and the capabilities of your
        facility.
      </Typography>

      <WaitTimeForm data={data} />
      <CapabilitiesForm data={data} />
    </div>
  );
};

export default StatusBoardPage;
